import styled from 'styled-components';
import * as T from '../../common/Typography';

export const Form = styled.form`
  box-sizing: border-box;
  border-radius: 0.75rem;
`;

export const BackButtonWrapper = styled.div`
  width: 7.5rem;
  margin-bottom: 1.5rem;
`;

export const BackLabel = styled.span`
  display: inline-flex;
  align-items: center;
  gap: 0.5rem;
`;

export const BackChevron = styled.span`
  display: inline-flex;
  transform: rotate(90deg);
`;

export const OrSeparator = styled(T.P)`
  margin-top: 3.5rem;
  text-align: center;
`;

export const NameMatchBanner = styled.div`
  background-color: ${({ theme }) => theme.colors.primary};
  border-radius: 0.5rem;
  padding: 1rem;
  margin-bottom: 1.5rem;
`;
